import 'jspolyfill-array.prototype.findIndex';
import localStorageReducer from './localStorage';
import dictionaryReducer from './dictionary';
import sportsReducer from './sports';
import favouritesReducer from './favourites';
import tooltipReducer from './tooltip';

const rootReducer = {
  localStorageReducer,
  dictionaryReducer,
  sportsReducer,
  favouritesReducer,
  tooltipReducer,
};

export default rootReducer;
